import { render, staticRenderFns } from "./img.vue?vue&type=template&id=42ded9ff&scoped=true&"
import script from "./img.vue?vue&type=script&lang=js&"
export * from "./img.vue?vue&type=script&lang=js&"
import style0 from "./img.vue?vue&type=style&index=0&id=42ded9ff&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ded9ff",
  null
  
)

export default component.exports